export const formatDate = (value: Date | string | null | undefined): string => {
  if (!value) return '--';

  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return '--';

  return new Intl.DateTimeFormat('en-GB', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  }).format(date);
};

export const formatDateIfLikely = (value: string): string => {
  if (!value) return value;

  const looksLikeDate =
    /^\d{4}-\d{2}-\d{2}/.test(value) ||
    /^\d{2}\/\d{2}\/\d{4}/.test(value) ||
    value.includes('T');

  if (!looksLikeDate) return value;

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;

  return formatDate(date);
};
